class Global {
    static getAppSettings() {
        return Global.appSettings;
    }

    static setAppSettings(appSettings) {
        Global.appSettings = appSettings
    }

    static getRestrictedEnvironments() {
        return Global.restrictedEnvironments;
    }

    static setRestrictedEnvironments(environments) {
        Global.restrictedEnvironments = environments;
    }

    static getRouter() {
        return Global.router
    }

    static setRouter(router) {
        Global.router = router;
    }

    static getStore() {
        return Global.store;
    }

    static setStore(store) {
        Global.store = store;
    }
}

export default {
    getAppSettings: Global.getAppSettings,
    setAppSettings: Global.setAppSettings,
    getRestrictedEnvironments: Global.getRestrictedEnvironments,
    setRestrictedEnvironments: Global.setRestrictedEnvironments,
    getRouter: Global.getRouter,
    setRouter: Global.setRouter,
    getStore: Global.getStore,
    setStore: Global.setStore,
    defaultPageSize: 10
}